var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownchevronDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.78076 8.77306C6.38044 9.27328 5.61956 9.27328 5.21924 8.77306L1.30033 3.87619C0.776358 3.22145 1.24251 2.25136 2.08109 2.25136L9.91891 2.25136C10.7575 2.25136 11.2236 3.22145 10.6997 3.87619L6.78076 8.77306Z",
    fill: "#E3ECF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownchevronDark);
export default __webpack_public_path__ + "static/media/downchevron_dark.45ae41deff48df5e2b80ac16d7f673fc.svg";
export { ForwardRef as ReactComponent };